import { apiJS as baseApi } from "store/api";

export const TAG_DATA_SOURCE = "DATA_SOURCE";

export type DataSourceParameterValue = string | number | boolean;
export type DataSourceParameter = { name: string; value: DataSourceParameterValue };

export type GetDataSourceOptionsV1 = {
    apiVersion: "v1";
    id: string;
    parameters?: DataSourceParameter[];
};
export type GetDataSourceOptionsV2 = {
    apiVersion: "v2";
    path: string;
    parameters?: Record<string, string | number | boolean | null>;
};
export type GetDataSourceOptions = GetDataSourceOptionsV1 | GetDataSourceOptionsV2;

const api = baseApi
    .enhanceEndpoints({
        addTagTypes: [TAG_DATA_SOURCE],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getDataSource: builder.query<any, GetDataSourceOptions>({
                query: (options) => {
                    const { apiVersion } = options;

                    let url = `data-source/${apiVersion}`;

                    if (options.apiVersion === "v1") {
                        const { id, parameters } = options;
                        url += `/${id}`;
                        // Parameters in array
                        if (parameters) {
                            url += `?parameters=${encodeURIComponent(JSON.stringify(parameters))}`;
                        }
                    } else if (options.apiVersion === "v2") {
                        const { path, parameters } = options;
                        url += `/${path}`;
                        // Parameters in object
                        if (parameters) {
                            const search = new URLSearchParams();
                            Object.entries(parameters).forEach(([key, value]) => {
                                search.append(key, String(value));
                            });
                            const qs = search.toString();
                            if (qs) url += `?${qs}`;
                        }
                    }
                    return {
                        url,
                        method: "GET",
                    };
                },
                providesTags: (_result, _error, arg) => [{ type: TAG_DATA_SOURCE, id: JSON.stringify(arg) }],
            }),
        }),
    });

export { api as dataSourceApi };
export const { useGetDataSourceQuery, useLazyGetDataSourceQuery } = api;
